module.exports = __webpack_public_path__ + "static/31-8ac9dca04a41a90cb474b1172cc3435e.png";